import * as React from "react";

import { styled, useTheme } from "@mui/material/styles";

import { useMediaQuery } from "@mui/material";

import MuiDrawer from "@mui/material/Drawer";

import Box from "@mui/material/Box";

import Toolbar from "@mui/material/Toolbar";

import IconButton from "@mui/material/IconButton";

import Container from "@mui/material/Container";

import CssBaseline from "@mui/material/CssBaseline";

import GlobalStyles from "@mui/material/GlobalStyles";

import { Navigate, Outlet } from "react-router-dom";

import SidebarMenu from "./SidebarMenu";

import workz360 from "../images/workz360.png";

import Navbar from "./Navbar";

import { useCurrentUser } from "../hooks/useCurrentUser";

import SiteBreadcrumb from "./SiteBreadcrumb";

import { useCompany } from "../hooks/useCompany";

import { CompanyStatus } from "../types/company";

import { Alert, AlertTitle, colors } from "@mui/material";

import { isProductionMode } from "../utils/helper";

import CornerRibbon from "./CornerRibbon";



const drawerWidth: number = 240;



const PermanentDrawer = styled(MuiDrawer, {

  shouldForwardProp: (prop) => prop !== "open",

})(({ theme, open }) => ({

  width: open ? drawerWidth : theme.spacing(7),

  flexShrink: 0,

  whiteSpace: "nowrap",

  boxSizing: "border-box",

  transition: theme.transitions.create("width", {

    easing: theme.transitions.easing.sharp,

    duration: theme.transitions.duration.enteringScreen,

  }),

  "& .MuiDrawer-paper": {

    width: open ? drawerWidth : theme.spacing(7),

    transition: theme.transitions.create("width", {

      easing: theme.transitions.easing.sharp,

      duration: theme.transitions.duration.enteringScreen,

    }),

    overflowX: "hidden",

    overflowY: "auto",

    boxSizing: "border-box",

    display: "flex",

    flexDirection: "column",

    backgroundColor: theme.palette.mode === "dark"

      ? "rgba(18, 18, 18, 0.85)"

      : "rgba(255, 255, 255, 0.85)",

    backdropFilter: "blur(20px) saturate(180%)",

    WebkitBackdropFilter: "blur(20px) saturate(180%)",

    borderRight: `1px solid ${theme.palette.mode === "dark"

      ? "rgba(255, 255, 255, 0.1)"

      : "rgba(0, 0, 0, 0.08)"

      }`,

    // Start drawer from below navbar (mobile navbar is 30px, desktop is 44px based on user changes)

    top: { xs: "30px", sm: "44px" },

    height: { xs: "calc(100% - 30px)", sm: "calc(100% - 44px)" },

    [theme.breakpoints.up("sm")]: {

      width: open ? drawerWidth : theme.spacing(9),

    },

  },

}));



const loading = () => <div className="text-center">Loading...</div>;



const ProtectedPageLayout = () => {

  // const token = useAppSelector((state) => state.auth.token);

  const user = useCurrentUser();

  const company = useCompany();

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Initialize state: mobile starts closed, desktop starts open

  const [open, setOpen] = React.useState(() => {

    if (typeof window !== "undefined") {

      return window.innerWidth >= theme.breakpoints.values.sm;

    }

    return true; // Default to open

  });



  const toggleDrawer = () => {

    console.log("toggleDrawer called, current open:", open);

    setOpen((prev) => {

      console.log("Setting open to:", !prev);

      return !prev;

    });

  };

  const isProduction = React.useMemo(() => isProductionMode(), []);

  const companyLogo = React.useMemo(

    () => company?.logo?.[0]?.original_url || null,

    [company]

  );



  React.useEffect(() => {

    document.body.classList.add("app-layout--with-navbar");

    return () => {

      document.body.classList.remove("app-layout--with-navbar");

    };

  }, []);



  if (!user) return <Navigate to="/login" replace />;



  return (

    <Box sx={{ display: "flex", height: "100vh", width: "100%", overflow: "hidden" }}>

      <CssBaseline />

      <GlobalStyles

        styles={(theme) => ({

          ".app-layout--with-navbar .MuiDrawer-root.MuiDrawer-anchorRight": {

            top: "44px",

            height: "calc(100% - 44px)",

            [theme.breakpoints.down("sm")]: {

              top: "30px !important",

              height: "calc(100% - 30px) !important",

              zIndex: theme.zIndex.drawer,

            },

          },

          ".app-layout--with-navbar .MuiDrawer-root.MuiDrawer-anchorRight .MuiPaper-root": {

            top: "44px",

            height: "calc(100% - 44px)",

            [theme.breakpoints.down("sm")]: {

              top: "30px !important",

              height: "calc(100% - 30px) !important",

              zIndex: theme.zIndex.drawer,

            },

          },

        })}

      />

      <Navbar open={open} onToggle={toggleDrawer} />

      {isMobile ? (

        <MuiDrawer

          variant="temporary"

          open={open}

          onClose={() => {

            console.log("Drawer onClose called");

            setOpen(false);

          }}

          ModalProps={{

            keepMounted: true, // Better open performance on mobile.

            sx: {

              zIndex: (theme) => theme.zIndex.drawer,

              "& .MuiBackdrop-root": {

                top: "30px !important",

                height: "calc(100% - 30px) !important",

                zIndex: (theme) => theme.zIndex.drawer - 1,

              },

            },

          }}

          sx={{

            zIndex: (theme) => theme.zIndex.drawer,

            "& .MuiBackdrop-root": {

              top: "30px !important",

              height: "calc(100% - 30px) !important",

            },

            "& .MuiDrawer-paper": {

              width: drawerWidth,

              backgroundColor: (theme: any) =>

                theme.palette.mode === "dark"

                  ? "rgba(18, 18, 18, 0.85)"

                  : "rgba(255, 255, 255, 0.85)",

              backdropFilter: "blur(20px) saturate(180%)",

              WebkitBackdropFilter: "blur(20px) saturate(180%)",

              borderRight: (theme: any) =>

                `1px solid ${theme.palette.mode === "dark"

                  ? "rgba(255, 255, 255, 0.1)"

                  : "rgba(0, 0, 0, 0.08)"

                }`,

              // Start drawer from below navbar (mobile navbar is 30px)

              top: "30px !important",

              height: "calc(100% - 30px) !important",

              position: "fixed",

              zIndex: (theme) => theme.zIndex.drawer,

            },

          }}

        >

          {!isProduction && (

            <CornerRibbon

              backgroundColor={colors.yellow[200]}

              fontColor="#333"

              position="top-left"
              style={{
                marginTop: "60px",
              }}

            >

              STAGING

            </CornerRibbon>

          )}

          <Toolbar

            sx={{

              display: "flex",

              alignItems: "center",

              justifyContent: "space-between",

              px: { xs: 1.5, sm: 1.5 },

              py: { xs: 1.5, sm: 0 },

              minHeight: { xs: "56px !important", sm: "64px !important" },

              zIndex: 1,

              position: { xs: "relative", sm: "sticky" },

              top: { xs: 0, sm: 0 },

              mt: { xs: 9, sm: 0 },

              backgroundColor: (theme: any) =>

                theme.palette.mode === "dark"

                  ? "rgba(18, 18, 18, 0.85)"

                  : "rgba(255, 255, 255, 0.85)",

              backdropFilter: "blur(20px) saturate(180%)",

            }}

          >

            <img

              src={companyLogo || workz360}

              height={40}

              alt="Logo"

              style={{

                maxHeight: "40px",

                width: "auto",

                objectFit: "contain",

              }}

            />

            {/* <IconButton onClick={() => setOpen(false)} sx={{ ml: "auto" }}>

              <ChevronLeftIcon />

            </IconButton> */}

          </Toolbar>

          <Box

            sx={{

              overflowY: "auto",

              overflowX: "hidden",

              flex: 1,

              "&::-webkit-scrollbar": {

                width: "6px",

              },

              "&::-webkit-scrollbar-thumb": {

                backgroundColor: (theme) =>

                  theme.palette.mode === "dark"

                    ? "rgba(255, 255, 255, 0.2)"

                    : "rgba(0, 0, 0, 0.2)",

                borderRadius: "3px",

              },

            }}

          >

            <SidebarMenu open={open} onClose={() => setOpen(false)} />

          </Box>

        </MuiDrawer>

      ) : (

        <PermanentDrawer variant="permanent" open={open}>

          {!isProduction && (

            <CornerRibbon

              backgroundColor={colors.yellow[200]}

              fontColor="#333"

              position="top-left"

            >

              STAGING

            </CornerRibbon>

          )}

          <Toolbar

            sx={{

              display: open ? "flex" : "none", // Hide toolbar when drawer is closed

              alignItems: "center",

              justifyContent: "space-between",

              px: [1.5],

              minHeight: "64px !important",

              zIndex: 1,

              position: "sticky",

              top: 0,

              backgroundColor: (theme) =>

                theme.palette.mode === "dark"

                  ? "rgba(18, 18, 18, 0.85)"

                  : "rgba(255, 255, 255, 0.85)",

              backdropFilter: "blur(20px) saturate(180%)",

            }}

          >

            <img src={companyLogo || workz360} height={40} alt="Logo" />

            {/* <IconButton onClick={toggleDrawer} sx={{ ml: "auto" }}>

              <ChevronLeftIcon />

            </IconButton> */}

          </Toolbar>

          <Box

            sx={{

              overflowY: "auto",

              overflowX: "hidden",

              flex: 1,

              "&::-webkit-scrollbar": {

                width: "6px",

              },

              "&::-webkit-scrollbar-thumb": {

                backgroundColor: (theme) =>

                  theme.palette.mode === "dark"

                    ? "rgba(255, 255, 255, 0.2)"

                    : "rgba(0, 0, 0, 0.2)",

                borderRadius: "3px",

              },

            }}

          >

            <SidebarMenu open={open} />

          </Box>

        </PermanentDrawer>

      )}

      <Box

        component="main"

        sx={{

          flexGrow: 1,

          display: "flex",

          flexDirection: "column",

          width: {

            xs: "100%", // Mobile: full width, drawer overlays

            sm: `calc(100% - ${open ? drawerWidth : theme.spacing(9)}px)`, // Desktop: adjust width

          },

          backgroundImage: "url('/new-background-home.png')",

          backgroundSize: "cover",

          backgroundPosition: "center",

          backgroundRepeat: "no-repeat",

          backgroundAttachment: "fixed",

          minHeight: "100vh",

          overflow: "auto",

          position: "relative",

          transition: theme.transitions.create(["width", "margin"], {

            easing: theme.transitions.easing.sharp,

            duration: theme.transitions.duration.enteringScreen,

          }),

          "&::before": {

            content: '""',

            position: "fixed",

            top: 0,

            left: 0,

            right: 0,

            bottom: 0,

            width: "100%",

            height: "100%",

            backgroundColor: "rgba(255, 255, 255, 0.5)",

            zIndex: 0,

            pointerEvents: "none",

            // GPU acceleration for smooth scrolling

            transform: "translateZ(0)",

            willChange: "transform",

            backfaceVisibility: "hidden",

          },

        }}

      >

        {/* Toolbar untuk spacing di bawah navbar */}

        {/* <Toolbar sx={{ minHeight: { xs: "300px !important", sm: "30px !important" } }} /> */}

        <Container

          maxWidth={false}

          sx={{

            mt: 15,

            mb: 3,

            px: { xs: 0.75, sm: 1.5, md: 1.5 },

            pl: {

              xs: 0.75,

              sm: open ? 1.5 : 3, // Tambah padding kiri ketika drawer tertutup

              md: open ? 1.5 : 3,

            },

            flexGrow: 1,

            display: "flex",

            flexDirection: "column",

            position: "relative",

            zIndex: 1,

          }}



        >

          <SiteBreadcrumb />

          {company?.status == CompanyStatus.PENDING && (

            <Alert severity="warning" sx={{ mb: 2 }}>

              <AlertTitle>Account Pending</AlertTitle>

              The Workz360 approvals team is still in the process of setting up

              your account.

            </Alert>

          )}

          {company?.status == CompanyStatus.INACTIVE && (

            <Alert severity="warning" sx={{ mb: 2 }}>

              <AlertTitle>Account Disabled</AlertTitle>

              Your account is disabled. Please contact the Administrator for

              further information.

            </Alert>

          )}



          <Box sx={{ flexGrow: 1 }}>

            <React.Suspense fallback={loading()}>

              <Outlet />

            </React.Suspense>

          </Box>

        </Container>

      </Box>

    </Box>

  );

};

export default ProtectedPageLayout;
